import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { ArgoConnectionKindEnum } from '@redviking/argonaut-util/types/db-enums/argo/connection_kind';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const openProtocolConnectionNodeSpec: NodeSpec<NodeCfg<'openProtocolConnection'>> = {
    cfg: () => ({
        id: getUID(),
        kind: 'openProtocolConnection',
        width: 220,
        controlValues: {
            connectionId: '',
        },
    }),
    controls: nodeCfg => ({
        connectionId: defineControlOpts({
            cfg: {
                kind: 'connectionSelect',
                label: 'Connection',
                allowedConnectionKinds: [ ArgoConnectionKindEnum.OpenProtocol ],
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.connectionId,
        }),
    }),
    inputs: () => ({}),
    kindLabel: 'Open Protocol connection',
    nodeCategory: 'connection',
    outputs: () => ({}),
    requiredSockets: 'none',
    validator: node => node.controlValues.connectionId ? true : { connectionId: 'Connection id is required' },
    suppressNode: true,
};
